import React from 'react';
import { Box } from '@mui/material';
import Logo from './../../assets/images/Home/Logo.png'
import Menu from '../../assets/icons/NavbarIcon/menu-03.png'
import Search from '../../assets/icons/NavbarIcon/Icon-1.png'
import Cart from '../../assets/icons/NavbarIcon/Icon.png'
import SideMenu from './SideMenu';
import { Link } from 'react-router-dom';




const UnAuthMobileNav = () => {
  return (
    <>
 <Box sx={{
          width:"100%",
      height:"10vh",
      backgroundColor:"#fff",
      display:{md:"none",xs:"flex"},
      justifyContent:"center",
      position:"fixed",
      boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', // Add box shadow
      zIndex:"10",
    }} >
    <Box sx={{
        width:"25%",
        height:"100%",
        display:"flex",
        alignItems:"center",
        justifyContent:"start",
    }} >
    <Box 
    sx={{
        width:"40%",
        height:"40%"
    }}
     >
         <SideMenu/>
    </Box>


    </Box>
    <Box sx={{
        width:"40%",
        height:"100%",
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
    }} >
      <Box sx={{
          height:"60%",
          display:"flex",
          justifyContent:"center",
          alignItems:"center"
      }} >
        <img 
          src={Logo} 
          alt="Logo"
          style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
        />
      </Box>
     

    </Box>
     <Box sx={{
        width:"30%",
        height:"100%",
        display:"flex",
        alignItems:"center",
        justifyContent:"end"
    }} >
    
    <Box 
    sx={{
        width:"20%",
        height:"30%",
        marginLeft:"20%",
        marginRight:"10%",

    }}
     >
           

   
    </Box>

    </Box>
    </Box>
    <Box sx={{
        width:"100%",
        height:"10vh",
        display:{xs:"flex",md:"none"}
    }} >
        
    </Box>
    </>
   
  )
}

export default UnAuthMobileNav
